import axios from 'axios';
import CitizenConfig from '../config';
import { openModal } from './ModalLoginActions';

export const ADD_TO_FAVORITES = 'ADD_TO_FAVORITES';
export const REMOVE_FROM_FAVORITES = 'REMOVE_TO_FAVORITES';
export const FETCH_FAVORITES = 'FETCH_FAVORITES';
export const RECEIVE_FAVORITES = 'RECEIVE_FAVORITES';

const FAVORITES_API_URL = `${CitizenConfig.API_URL}/citizen/account/favorites`;

export function addToFavorite(pProduct) {
  return (dispatch, getState) => {
    let { user } = getState();

    if (user.authenticated) {
      return axios
        .post(FAVORITES_API_URL, { product_id: pProduct.id }, {
          headers: {
            'Authorization': `Bearer ${user.data.token}`
          }
        })
        .then((res) => {
          dispatch({
            type: ADD_TO_FAVORITES,
            item: pProduct
          })
        });
    } else {
      dispatch(openModal());
    }
  }
};


export function removeFromFavorite(pProductId) {
  return (dispatch, getState) => {
    let { user } = getState();

    if (user.authenticated) {
      return axios
        .delete(FAVORITES_API_URL, {
          params: { product_id: pProductId },
          headers: {
            'Authorization': `Bearer ${user.data.token}`
          }
        })
        .then(() => {
          dispatch({
            type: REMOVE_FROM_FAVORITES,
            item: pProductId
          })
        })
    } else {
      dispatch(openModal());
    }
  }
};

export function getFavorites() {
  return (dispatch, getState) => {
    let { user } = getState();

    if (user.authenticated) {
      dispatch({
        type: FETCH_FAVORITES
      })

      return axios
        .get(`${FAVORITES_API_URL}?per_page=100`, {
          headers: {
            'Authorization': `Bearer ${user.data.token}`
          }
        })
        .then(async (res) =>  {
          let totalPages = res.headers['x-wp-totalpages'];

          dispatch({
            type: RECEIVE_FAVORITES,
            items: res.data
          });

          for (let currentPage = 2; currentPage <= totalPages; currentPage++) {
            let results = await axios
              .get(`${FAVORITES_API_URL}?per_page=100&page=${currentPage}`, {
                headers: {
                  'Authorization': `Bearer ${user.data.token}`
                }
              });
            dispatch({
              type: RECEIVE_FAVORITES,
              items: results.data
            });
          }
        });
    } else {
      dispatch(openModal());
    }
  }
};


// WEBPACK FOOTER //
// ./src/actions/FavoritesActions.js